import { render, staticRenderFns } from "./ModalUpdateSelection.vue?vue&type=template&id=131317bd&"
import script from "./ModalUpdateSelection.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports